// extracted by mini-css-extract-plugin
export var flex__auto__end = "styles-module--flex__auto__end--42ad7";
export var flex__between = "styles-module--flex__between--1ee49";
export var flex__between__center = "styles-module--flex__between__center--14695";
export var status__icon = "styles-module--status__icon--81546";
export var status__text = "styles-module--status__text--5fc1d";